import React, { useEffect } from 'react'

import { ScrollView, StyleSheet, Linking, View } from 'react-native'

import { useContent } from '@sart/content'
import { MenuList } from '@sart/components'
import { adaptive, colors, typography } from '@sart/styles'
import { testID } from '@sart/utilities'

export default function Legal(props) {
  const content = useContent()

  const { navigation } = props

  function handleRouting(item) {
    if (item.link) {
      return Linking.openURL(item.link)
    }
    navigation.navigate(item.id)
  }

  const menuItems = [
    {id: 'About', label: content.navigation.about},
    {id: 'TermsOfService', label: content.legal.termsOfService, link: 'https://www.bikermobile.com/terms-of-service'},
    {id: 'PrivacyPolicy', label: content.legal.privacyPolicy, link: 'https://www.bikermobile.com/privacy-policy'},
    {id: 'VisitOurWebsite', label: content.legal.visitOurWebsite, link: 'https://www.bikermobile.com'}
  ]
  
  return (
    <ScrollView contentContainerStyle={styles.wrapper}>
      <View style={styles.widthRestrictions}>
        <MenuList color={colors.brightOrange}>
          {
            menuItems.map(item =>
              <MenuList.Item
                key={item.id}
                label={item.label}
                onPress={() => handleRouting(item)}
                style={styles.menuListItemStyle}
                {...testID(item.id)}
              />
            )
          }
        </MenuList>
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    paddingTop: 24,
    paddingBottom: 24,
    ...adaptive.wrapperPadding,
    width: '100%',
    alignItems: 'center'
  },
  titleText: {
    textAlign: 'center',
    color: colors.white,
    ...typography.demi,
    fontSize: 16
  },
  menuListItemStyle: {
    color: colors.white,
    ...typography.lightbold
  },
  widthRestrictions: {
    width: '100%',
    maxWidth: 600
  }
})
